<div class="profile-details">
  <div class="row text-center">
    <div class="col">
      <div class="header-icon margin-bottom mb8">
          <div *ngIf="whereInTheProcess === 'edit-email'; else pwdSVG">
          <svg-email-validate-svg></svg-email-validate-svg>
        </div>
        <ng-template #pwdSVG>
          <svg-create-new-password-svg></svg-create-new-password-svg>
          </ng-template>
      </div>
      <div *ngIf="whereInTheProcess === 'edit-email'; else enterPassword">
        <h1 class="title-copy no-margin">{{ 'PROFILE_EMAIL_ONE' | translate }}</h1> 
      </div> 
      <ng-template #enterPassword>
        <h1 class="title-copy no-margin">{{ 'PROFILE_EMAIL_TWO' | translate }}</h1> 
        <div>
        {{ 'PROFILE_PASSWORD_ONE' | translate }} 
        </div>
      </ng-template>
    </div>
  </div>
  <div>
    <div *ngIf="whereInTheProcess === 'edit-email'; else verifyPasswordForm">
      <app-edit-email-form [inputs]="verifyPassword" [userData]="user"></app-edit-email-form>   
    </div>
    <ng-template #verifyPasswordForm>
      <app-change-password-form [inputs]="verifyPassword" [userData]="user"></app-change-password-form>       
    </ng-template>
  </div>
</div>